import React, { useEffect } from 'react';
import { TalkToUsRouter } from './TalkToUsRouter';
import { FeaturesProvider } from 'components/FeaturesContext';

export default function TalkToUs(props) {
  const searchParams = new URL(document.location).searchParams;

  useEffect(() => {
    window?.gtag('event', 'digital_lead_begin');
    try {
      if (searchParams == null) return;

      let flow = searchParams.get('flow') == 'checkout';
      let plan = searchParams.get('plan');
      let practiceCode = searchParams.get('practice_code');
      window.sessionStorage.setItem('flow', flow ? 'checkout' : 'TTU');

      const isValid = ['reset', 'you'].includes(plan);
      window.sessionStorage.setItem('validQueryParams', isValid);
      if (isValid) {
        window.sessionStorage.setItem('plan', plan);
      }

      if (practiceCode != undefined) {
        window.sessionStorage.setItem('practiceCode', practiceCode);
      }

      if (flow) {
        window.localStorage.setItem('form_variant', 'Nue life digital sale');
      }
    } catch { }
  }, [searchParams]);

  return (
    <FeaturesProvider>
      <TalkToUsRouter {...props} />
    </FeaturesProvider>
  );
}